<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Percepciones de IIBB - Compras</strong>
          </div>
          <b-form>
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model= "fechaDesde" 
                :state="fechaDesdeValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaDesdeFeedback">
                {{ fechaDesdeInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model= "fechaHasta" 
                :state="fechaHastaValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaHastaFeedback">
                {{ fechaHastaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import export_xls_compras from '../../mixins/export_xls_compras';
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal,
    export_xls_compras
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaDesdeValida: null,
      fechaDesdeInvalidaMsj: '',
      fechaHastaValida: null,
      fechaHastaInvalidaMsj: '',

      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      // proveedor: null,

      labelCols: 2,
    }
  },
  computed: {
    // proveedorNombre() {
    //   return this.proveedor? this.proveedor.nombre.trim() : '';
    // },
  },
  created() {
    
  },  
  methods: {
    validate() {

    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      // let proveedorId = 0;
      // if (this.proveedor) {
      //   proveedorId = this.proveedor.id;
      // }

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        // proveedorId
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('compraspercepcionesprovinciales/getRptPercepcionesCompras', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptPercepciones = this.$store.getters['compraspercepcionesprovinciales/rptPercepciones'];

            if (rptPercepciones) {
              if (rptPercepciones.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              this.exportXLSRptPercepcionesCompras(rptPercepciones);
            } else {
              this.showModalMsj('No hay datos para exportar', null, null, 'light');
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    // seleccionarProveedor() {
    //   if (this.proveedor) {
    //     this.proveedor = null;
    //   } else {
    //     this.$refs.searchProveedorModal.show();
    //   }
    // },
    // proveedorSeleccionado(item) {
    //   this.proveedor = item;
    //   this.$refs.searchProveedorModal.hide();
    // },
  },
}
</script>

<style>
</style>
